import React, { Component } from 'react'
import cn from 'classnames'
import './HelpText.css'

export type HelpTextProps = {
  className?: string
  style?: React.CSSProperties
  children: React.ReactNode
  testId?: string
  disabled?: boolean
}


export class HelpText extends Component<HelpTextProps> {

  render() {
    const { className, children, testId = "cs-help-text", disabled = false, ...otherProps } = this.props

    const classNames = cn('HelpText', className, {
      'HelpText--disabled': disabled === true
    })

    return (
      <p data-test-id={testId} {...otherProps} className={classNames}>
        {children}
      </p>
    )
  }
}

export default HelpText
